/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
/* eslint-enable no-restricted-imports */
import { useCallback, useState } from "react";

/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */

/**
 * SPWN ユーザーに紐づく start.gg 連携情報。
 * アクセストークンは持たず、突合に使う user.id と表示用の gamerTag だけを持つ。
 *
 * 保存先は localStorage。端末やブラウザを跨げないため本実装ではサーバ保存に移すが、
 * 連携フローが成立するかの実証はこの範囲でできる。
 */
export type StartggLink = {
  userId: string;
  username: string;
  linkedAt: number;
};

const storageKey = (uid: string) => `startggLink:${uid}`;

const readLink = (): StartggLink | null => {
  const uid = firebase.auth().currentUser?.uid;
  if (!uid) {
    return null;
  }
  const raw = localStorage.getItem(storageKey(uid));
  if (!raw) {
    return null;
  }
  return JSON.parse(raw) as StartggLink;
};

export const useStartggLink = () => {
  const [link, setLink] = useState<StartggLink | null>(() => readLink());

  const save = useCallback((next: StartggLink): void => {
    const uid = firebase.auth().currentUser?.uid;
    if (!uid) {
      throw new Error("not logged in");
    }
    localStorage.setItem(storageKey(uid), JSON.stringify(next));
    setLink(next);
  }, []);

  /**
   * SPWN 側の連携解除。保存した start.gg 情報を忘れるだけで、
   * start.gg 側の認可の取り消しは start.gg の設定画面で別途行う。
   */
  const clear = useCallback((): void => {
    const uid = firebase.auth().currentUser?.uid;
    if (uid) {
      localStorage.removeItem(storageKey(uid));
    }
    setLink(null);
  }, []);

  return { link, save, clear };
};
